/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

export const validationUniqueSymbolsPassword = (
  password: string,
  uniqueSymbolsCount: number
) => {
  if (uniqueSymbolsCount <= 1) return true;

  const numbers = /[0-9]/.test(password) ? 1 : 0;
  const lowerCaseLetter = /[a-z]/.test(password) ? 1 : 0;
  const upperCaseLetter = /[A-Z]/.test(password) ? 1 : 0;
  const specialSymbols = /[^a-zA-Z0-9\s]/.test(password) ? 1 : 0;

  return (
    numbers + lowerCaseLetter + upperCaseLetter + specialSymbols >=
    uniqueSymbolsCount
  );
};
